import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { EventResponseCategory } from '../../types/event-response.type';

@Component({
  selector: 'app-category-badge',
  templateUrl: './category-badge.component.html',
  styleUrls: ['./category-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  //Adding style because ngbTooltip is not loading it from scss.
  styles: [
    `
      .category-badge-tooltip .tooltip-inner {
        max-height: 7rem;
        border-radius: 0.5rem;
        overflow: auto;
        color: var(--neutral-000);
        font-size: 0.75rem;
        font-weight: 600;
        text-align: left;
        padding: 0.5rem 0.75rem;
        background-color: var(--colors-gray-950);
        box-shadow: var(--shadow);
      }

      .tooltip.show {
        opacity: 1;
      }

      .category-badge-tooltip.bs-tooltip-end .tooltip-arrow::before {
        border-right-color: var(--colors-gray-950);
      }
      .category-badge-tooltip.bs-tooltip-start .tooltip-arrow::before {
        border-left-color: var(--colors-gray-950);
      }
      .category-badge-tooltip.bs-tooltip-top .tooltip-arrow::before {
        border-top-color: var(--colors-gray-950);
      }
      .category-badge-tooltip.bs-tooltip-bottom .tooltip-arrow::before {
        border-bottom-color: var(--colors-gray-950);
      }

      .category-badge-tooltip .tooltip-inner a {
        color: var(--neutral-000);
      }

      .category-badge-tooltip .tooltip-inner a:hover {
        text-decoration: underline;
      }
    `,
  ],
})
export class CategoryBadgeComponent {
  @Input() title: string | undefined = undefined;
  @Input() tooltipCategories: EventResponseCategory[] | undefined = undefined;
  @Input() color: string;
  @Input() isLink: boolean = false;

  get cssClassAddOn(): Record<string, boolean> {
    return {
      [`category-badge--${this.color}`]: Boolean(this.color),
      'category-badge--is-link': this.isLink,
    };
  }

  get cssClassTextAddOn(): Record<string, boolean> {
    return {
      [`category-badge__text--${this.color}`]: Boolean(this.color),
    };
  }
}
